import React from 'react';
import { Link } from 'react-router-dom';

export default function SimpleHeader() {
  const logoSrc = (process.env.PUBLIC_URL || "") + "/logo.png"; // public/logo.png

  return (
    <header className="fixed top-0 w-full z-50 bg-white border-b border-gray-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center">
        <Link to="/" className="flex items-center gap-3 group" aria-label="Anora ana sayfa">
          <span className="size-12 md:size-16 rounded-2xl bg-rose-500/10 ring-1 ring-rose-200/50 relative overflow-hidden grid place-items-center">
            <img
              src={logoSrc}
              alt="Anora"
              className="w-[44px] h-[44px] md:w-[60px] md:h-[60px] object-contain"
              aria-hidden
            />
          </span>
          <span className="font-semibold tracking-tight text-2xl text-gray-800">
            <span className="text-[#e45078] font-cormorant font-bold text-3xl">Anora</span>
          </span>
        </Link>
      </div>
    </header>
  );
}
